import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { CostUnitGroupDialogComponent } from './cost-unit-group-dialog.component';

export * from './cost-unit-group-dialog.component';
@NgModule({
    declarations: [ CostUnitGroupDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
    ],
})
export class CostUnitGroupDialogModule {
}
